import { Img, Heading } from "./..";
import React from "react";
import { Link } from "react-router-dom";
import useIsMobile from "../../utils/useIsMobile";

export default function Footer({ ...props }) {
  const isMobile = useIsMobile();


  return (
    <footer
      {...props}
      className={`flex justify-center items-center flex-col sw-full bg-white mb-[2vw] sm:mb-[16px]`}
    >
      <div className="mt-[120px] sm:w-[90vw] w-[85vw] flex justify-center">
          <div className="w-[100%] flex sm:flex-col mb-[16px] items-center sm:items-start justify-between md:flex-wrap sm:gap-[16px] sm:mb-[0px]">
            
            <div className="sm:w-full">
              <Img
                src="images/img_vector.svg"
                alt="Footerlogo"
                className="h-[2.3vw] sm:h-[40px] md:h-[40px] md:mb-[16px]"
              />
            </div>
            <div className="flex gap-[8vw] sm:flex-col sm:gap-[32px]">
              <div className="flex flex-col items-start gap-[1vw] md:gap-[16px]">
                <Heading as="p" className="text-gray-400 text-[.8vw] md:text-[16px]"> FOLLOW US</Heading>
                <div className="sm:w-full h-[24px] flex items-start gap-[24px]">
                  <Link to="https://www.facebook.com/profile.php?id=61574180846659">
                    <Img
                      src="images/facebook.svg"
                      alt="Facebook"
                      className="sm:h-[20px] sm:w-[20px] md:h-[24px] md:w-[24px] h-[1.1vw]"
                    />
                  </Link>
                  <Link to="https://www.instagram.com/lifetoon.me?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">
                    <Img
                      src="images/instagram.svg"
                      alt="Instagram"
                      className="sm:h-[20px] sm:w-[20px] md:h-[24px] md:w-[24px] h-[1.1vw]"
                    />
                  </Link>
                  <Link to="https://www.threads.net/@lifetoon.me">
                    <Img
                      src="images/threads.svg"
                      alt="Threads"
                      className="sm:h-[20px] sm:w-[20px] md:h-[24px] md:w-[24px] h-[1.1vw]"
                    />
                  </Link>
                  <Link to="https://www.tiktok.com/@lifetoon.me?lang=en">
                    <Img
                      src="images/Tiktok.svg"
                      alt="TikTok"
                      className="sm:h-[20px] sm:w-[20px] md:h-[24px] md:w-[24px] h-[1.1vw]"
                    />
                  </Link>
                  <Link to="https://www.linkedin.com/company/lifetoon/posts/?feedView=all">
                    <Img
                      src="images/linkedin.svg"
                      alt="linkedin"
                      className="sm:h-[20px] sm:w-[20px] md:h-[24px] md:w-[24px] h-[1.1vw]"
                    />
                  </Link>
                </div>
              </div>
              <div className="flex flex-col items-start gap-[.8vw] md:gap-[16px]"> 
                <Heading as="p" className="text-gray-400 text-[.8vw] md:text-[16px]"> CONTACT US</Heading>
                <a
                  href="mailto:office@lifetoon.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue_gray-300 hover:text-blue_gray-500 text-[1vw] md:text-[16px]"
                >
                  office@lifetoon.me
                </a>
              </div>
              <div className="flex flex-col items-start gap-[.8vw] md:gap-[16px]">
                <Heading as="p" className="text-gray-400 text-[.8vw] md:text-[16px]"> READ MORE</Heading>
                <div className="flex gap-[1vw] md:gap-[16px]">
                  <Link to="/terms" no-font={true} className="font-inter text-gray-400 text-[1vw] md:text-[16px] sm:text-[14px]">Terms of Use</Link>
                  <Link to="/privacy" no-font={true} className="font-inter text-gray-400 text-[1vw] md:text-[16px] sm:text-[14px]">Privacy Policy</Link>
                  <Link to="/cookiepolicy" no-font={true} className="font-inter text-gray-400 text-[1vw] md:text-[16px] sm:text-[14px]">Cookie Policy</Link>
                </div>
              </div>
            </div>
          </div>
      </div>
      {isMobile && <hr class="w-[90vw] border-gray-200 dark:border-white my-[24px]" />}
      <Heading  as="p" className="sm:w-[90vw] w-[85vw] text-gray-400 text-[16px]">© 2025 Lifetoon. All rights reserved.</Heading>

    </footer>
  );
}
